module.exports = __webpack_public_path__ + "img/banner_xxyy.e6aee6fc.png";